module.exports = __webpack_public_path__ + "static/scape-formation-ii_acrylic-on-canvas-105x105in-2016-0bc23de28f5d4ee2a1ba684ed1935e4c.jpg";